import { render, staticRenderFns } from "./CoreView.vue?vue&type=template&id=2970c446&"
import script from "./CoreView.vue?vue&type=script&lang=js&"
export * from "./CoreView.vue?vue&type=script&lang=js&"
import style0 from "./CoreView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
